﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp').directive('formatMinutes', function () {
    return {
        restrict: 'A',
        scope: {
            inputMinutesValue: '=',
            formatType: '='
        },
        link: function (scope, element) {

            if (angular.isNumber(parseInt(scope.inputMinutesValue))) {

                var time = parseFloat(scope.inputMinutesValue);

                var hours = 0;
                var minutes = 0;

                if (!Number.isNaN(time)) {
                    hours = (time / 60) >> 0;
                    minutes = parseInt((time % 60).toFixed());
                }

                if (minutes === 60) {
                    hours += 1;
                    minutes = 0;
                }

                var hoursFormat = 'hr';
                var minutesFormat = 'min';

                if (scope.formatType) {
                    switch (scope.formatType) {
                        case 'shortFormat':
                            hoursFormat = 'h';
                            minutesFormat = 'm';
                            break;
                        case 'longFormat':
                            hoursFormat = 'hours';
                            minutesFormat = 'minutes';
                            break;
                    }
                }

                var returnValue = '{0} {2} {1} {3}'.format(hours, Math.abs(minutes), hoursFormat, minutesFormat);

                element.context.textContent = returnValue;
            }

            element.textContent = scope.inputMinutesValue;
        }
    };
});